import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AudioEditing from './audioediting';

export default class Audio extends Plugin {
  static get requires() {
    return [ AudioEditing ];
  }

  static get pluginName() {
    return 'Audio';
  }
}